<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { startUserStatusPolling, stopUserStatusPolling } from '@/utils/userStatusPoll'

export default {
  name: 'App',
  data() {
    return {
      versionTimer: null,
      versionNotified: false
    }
  },
  mounted() {
    if (localStorage.getItem('token')) {
      startUserStatusPolling()
    }
    this.checkVersion();
    this.versionTimer = setInterval(() => {
      this.checkVersion();
    }, 3 * 60 * 1000);
  },
  methods: {
    async checkVersion() {
      // 开发环境不检测版本
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      try {

        const res = await fetch(`/version.json?t=${Date.now()}`);

        const data = await res.json();

        const localVersion =
          localStorage.getItem('app_version');

        // 首次进入
        if (!localVersion) {

          localStorage.setItem(
            'app_version',
            data.version
          );

          return;
        }
        // 有新版本
        if (localVersion !== data.version) {

          // 存待更新版本
          localStorage.setItem(
            'next_version',
            data.version
          );

          // 防止重复通知
          if (!this.versionNotified) {

            this.versionNotified = true;

            this.$notify({
              title: 'Update Available',
              dangerouslyUseHTMLString: true,
              message: `
                <div style="display:flex;align-items:center;gap:12px;">
                  <span>
                    A new version is available
                  </span>

                  <button
                    id="refresh-version-btn"
                    style="
                      border:none;
                      background:#6C63FF;
                      color:#fff;
                      padding:4px 10px;
                      font-size:12px;
                      border-radius:6px;
                      cursor:pointer;
                    "
                  >
                    Refresh
                  </button>
                </div>
              `,
              type: 'warning',
              duration: 0,
              onClick: () => {}
            });
            this.$nextTick(() => {
              const btn = document.getElementById(
                'refresh-version-btn'
              );

              if (btn) {

                btn.onclick = () => {

                  const nextVersion =
                    localStorage.getItem('next_version');

                  if (nextVersion) {

                    localStorage.setItem(
                      'app_version',
                      nextVersion
                    );

                    localStorage.removeItem(
                      'next_version'
                    );

                  }

                  window.location.reload();

                };

              }

              });
          }
        }
      } catch (e) {

        console.log('版本检测失败');

      }
      }
  },
  beforeDestroy() {
    clearInterval(this.versionTimer);
    stopUserStatusPolling()
  },
}
</script>
<style lang="scss">
#app {
  font-family: Poppins, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,body,p{
  margin: 0px;
  padding: 0px;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.version-update-dialog {
  width: 480px !important;
  border-radius: 16px !important;
  padding: 12px;
  .el-message-box__header{
    padding: 15px 15px 10px !important;
  }
  .el-message-box__content{
    text-align: left !important;
  }
  .el-message-box__btns{
    text-align: right !important;
  }
}

.version-update-dialog .el-message-box__title {
  font-size: 18px;
  font-weight: 600;
  justify-content: flex-start !important;
}

.version-update-dialog .el-message-box__message {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 确认按钮 */
.version-confirm-btn {
  background: #6C63FF !important;
  border-color: #6C63FF !important;
  color: #fff !important;
  border-radius: 8px !important;
}

/* 取消按钮 */
.version-cancel-btn {
  border-radius: 8px !important;
}

</style>
